import { Box, Container } from '@mui/material';
import Subscription from '../subscription/Subscription';

// NoSubscription: container page to redirect the customer to, when they lack a valid license.
export default function NoSubscription(): React.ReactElement {
    return (
        <Container maxWidth="xl">
            <Box flex={1}>
                <Subscription />
            </Box>
        </Container>
    );
}
